import { render, staticRenderFns } from "./CalendarioVendaMobileEvento.vue?vue&type=template&id=81c36fb4&scoped=true"
import script from "./CalendarioVendaMobileEvento.vue?vue&type=script&lang=js"
export * from "./CalendarioVendaMobileEvento.vue?vue&type=script&lang=js"
import style0 from "./CalendarioVendaMobileEvento.vue?vue&type=style&index=0&id=81c36fb4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c36fb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cleverton/paytour-payt-1708/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81c36fb4')) {
      api.createRecord('81c36fb4', component.options)
    } else {
      api.reload('81c36fb4', component.options)
    }
    module.hot.accept("./CalendarioVendaMobileEvento.vue?vue&type=template&id=81c36fb4&scoped=true", function () {
      api.rerender('81c36fb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/apps/calendario_venda/CalendarioVendaMobileEvento.vue"
export default component.exports